<template>
  <div class="flashcards-container">

    <!-- 初始骨架屏 - 当没有flashcards时显示 -->
    <div class="flashcards-skeleton" v-if="this.flashcards?.length == 0 && !isGenerating">
      <div class="skeleton-header">
        <div class="skeleton-title"></div>
      </div>
      <div class="skeleton-card">
        <div class="skeleton-card-inner"></div>
        <div class="skeleton-navigation">
          <div class="skeleton-nav-arrow"></div>
          <div class="skeleton-card-count"></div>
          <div class="skeleton-nav-arrow"></div>
        </div>
      </div>
      <div class="skeleton-list">
        <div class="skeleton-item" v-for="index in 3" :key="index">
          <div class="skeleton-row">
            <div class="skeleton-term"></div>
            <div class="skeleton-divider"></div>
            <div class="skeleton-definition"></div>
            <div class="skeleton-edit"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成中的加载状态  英文提示-->
    <div class="generating-loader" v-if="isGenerating">
      <div class="loader-header">
        <div class="loader-icon">
          <i class="el-icon-loading"></i>
        </div>
        <div class="loader-title">Generating flashcards...</div>
        <div class="loader-subtitle">AI is analyzing your note content, please wait</div>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: progressWidth + '%' }"></div>
      </div>
      <div class="loader-steps">
        <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
          <div class="step-icon">1</div>
          <div class="step-text">Analyzing note</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
          <div class="step-icon">2</div>
          <div class="step-text">Extracting key</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
          <div class="step-icon">3</div>
          <div class="step-text">Generating flashcards</div>
        </div>
        <div class="step" :class="{ active: currentStep >= 4, completed: currentStep > 4 }">
          <div class="step-icon">4</div>
          <div class="step-text">Completed</div>
        </div>
      </div>
    </div>

    <!-- 正常的flashcards显示 -->
    <div class="cardbox" v-if="this.flashcards?.length > 0 && !isGenerating">
      <div class="header">
        <div class="title">
          <div class="subtitle">
            <span>{{ flashcards?.length }} flashcards to study</span>
          </div>
        </div>
        <div class="regenerate-button" @click="regenerateFlashcards">
          <i class="el-icon-refresh"></i> Regenerate
        </div>
      </div>
      <div class="card">
        <div class="card-inner" @click="flipCard" :class="{ 'is-flipped': isFlipped }">
          <div class="card-front" v-if="!isFlipped">
            <div class="card-content">{{ currentCard?.question }}</div>
          </div>
          <div class="card-back" v-else>
            <div class="card-content">{{ currentCard?.answer }}</div>
          </div>
        </div>
      </div>
      <div class="card-navigation">
        <span class="nav-arrow" @click.stop="prevCard">
          <i class="el-icon-back"></i> Return</span>
        <span class="card-count">{{ currentIndex + 1 }} / {{ flashcards?.length }}</span>
        <span class="nav-arrow" @click.stop="nextCard">
          Next <i class="el-icon-right"></i></span>
      </div>
    </div>

    <!-- <div class="action-buttons">
      <button class="action-button" @click="cardedit = !cardedit">
        <span class="button-icon">✏️</span>
        Edit
        <span class="arrow el-icon-arrow-right"></span>
      </button>
      <button class="action-button">
        <span class="button-icon">📚</span>
        Flashcards
        <span class="arrow el-icon-arrow-right"></span>
      </button>
    </div> -->
    <div class="flashcard-list">
      <div class="flashcard-item" v-for="(item, index) in flashcards" :key="index">
        <div class="row">
          <div class="showbox" v-if="!(cardedit && editindex == index)">
            <div class="item-term">
              <p>{{ item.question }}</p>
            </div>
            <div class="xiefen">
              <div class="xie"></div>
            </div>
            <div class="item-definition">{{ item.answer }}</div>
          </div>
          <div class="showbox" v-if="cardedit && editindex == index">
            <div class="item-term">
              <textarea v-model="item.question" class="tera-term"></textarea>
            </div>
            <div class="xiefen">
              <div class="xie"></div>
            </div>
            <div class="item-definition">
              <textarea v-model="item.answer" class="tera-term"></textarea>
            </div>
          </div>
          <div class="editbox">
            <div v-if="!(cardedit && editindex == index)" @click="
              cardedit = !cardedit;
            editindex = index;
            " class="editiconbox">
              <i class="el-icon-edit nnf-editicon"></i>
            </div>
            <div class="editoverbox" v-if="cardedit && editindex == index">
              <div @click="savechangecard()">
                <i class="el-icon-check editover"></i>
              </div>
              <div @click="cardedit = false">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noteobj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading_img: require("@/assets/images/noteindex/loading_img1.gif"),
      flashcards: [],
      currentIndex: 0,
      isFlipped: false,
      cardedit: false,
      editindex: 0,

      timer: null,
      isgetnew: false, //
      isGenerating: false,
      progressWidth: 0,
      currentStep: 1,

    };
  },
  computed: {
    currentCard() {
      if (!this.flashcards[this.currentIndex]) return null;
      return this.flashcards[this.currentIndex];
    },
  },
  mounted() {
    if (!this.noteobj || !this.noteobj.note_cards) return;

    this.flashcards = this.noteobj.note_cards;
    if (this.flashcards.length == 0) {
      console.log("No flashcards found for this note");
      this.getnewflashcards();
    }
  },
  methods: {
    async getnewflashcards() {
      if (!this.noteobj) return;

      // 开始生成状态
      this.isGenerating = true;
      this.progressWidth = 10;
      this.currentStep = 1;

      console.log(this.noteobj);
      let text = '';
      if (this.noteobj.live_transcript?.part_objs) {
        this.noteobj.live_transcript.part_objs.forEach((part) => {
          text += part.notes || '';
        });
      }
      if (text == '') {
        text = this.noteobj?.note_transcript || '';
      }

      if (!this.noteobj.noteid) {
        console.error("Missing noteid in noteobj");
        this.isGenerating = false;
        return;
      }

      // 更新进度
      this.progressWidth = 25;
      this.currentStep = 2;

      const res = await this.$axios.post("api/textaction/", {
        noteid: this.noteobj.noteid,
        language: this.noteobj.language || 'en',
        action: "text2flashcard",
        stream_action: "doc2flashcard_stream",
        text: text,
      });
      const redata = res.data;
      if (redata.code == 200) {
        // 轮训结果
        this.progressWidth = 40;
        this.currentStep = 3;
        this.pollForFlashcards(redata.noteid, 'flashcards');
      } else {
        this.isGenerating = false;
      }
    },
    async pollForFlashcards(noteid, key) {
      const INTERVAL = 2000;  // 每次轮询间隔 (毫秒)
      const MAX_TRIES = 100;   // 最大轮询次数

      for (let attempt = 0; attempt < MAX_TRIES; attempt++) {
        try {
          // 更新进度条
          const baseProgress = 40;
          const progressIncrement = 50 / MAX_TRIES;
          this.progressWidth = Math.min(90, baseProgress + (attempt * progressIncrement));

          // 查询 flashcards 生成状态
          const response = await this.$axios.post("api/getnotes_bykey/", { noteid: noteid, key: key });
          if (response.data.code === 200) {
            // 生成成功，处理 flashcards 数据
            this.currentStep = 4;
            this.progressWidth = 100;

            if (response.data.note_cards && response.data.note_cards[0]) {
              this.flashcards = response.data.note_cards[0];
              this.$emit("setflashcards", this.flashcards);
            }

            // 延迟一下再隐藏加载状态，让用户看到完成效果
            setTimeout(() => {
              this.isGenerating = false;
            }, 500);

            return; // 退出轮询
          }
        } catch (error) {
          console.error("Polling error: ", error);
        }
        // 如果未完成，等待一段时间再重试
        await new Promise(resolve => setTimeout(resolve, INTERVAL));
      }

      console.error("Max attempts reached. Flashcards generation failed.");
      this.isGenerating = false;
    },
    savechangecard() {
      if (!this.noteobj || !this.noteobj.noteid || !this.flashcards) return;

      this.cardedit = false;
      // 保存数据到数据库
      this.$axios.post("api/savechangecard/", {
        flashcards: JSON.stringify(this.flashcards),
        noteid: this.noteobj.noteid,
      });
    },
    flipCard() {
      this.isFlipped = !this.isFlipped;
    },
    nextCard() {
      if (!this.flashcards || this.flashcards.length === 0) return;

      this.currentIndex = (this.currentIndex + 1) % this.flashcards.length;
      this.isFlipped = false;
    },
    prevCard() {
      if (!this.flashcards || this.flashcards.length === 0) return;

      this.currentIndex =
        (this.currentIndex - 1 + this.flashcards.length) %
        this.flashcards.length;
      this.isFlipped = false;
    },
    async regenerateFlashcards() {
      this.flashcards = [];
      this.currentIndex = 0;
      this.isFlipped = false;
      this.isGenerating = true;
      this.progressWidth = 0;
      this.currentStep = 1;
      this.getnewflashcards();
    },
  },
  watch: {
    noteobj(val) {
      if (!val || !val.note_cards) return;

      this.flashcards = val.note_cards;
      this.currentIndex = 0;
      this.isFlipped = false;
    }
  },
};
</script>

<style lang="less" scoped>
/* 确保整个容器可滚动 */
.flashcards-container {
  overflow-y: auto;
  /* 允许垂直滚动 */
  margin-bottom: 24px;
  padding: 0 20px;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}

.flashcards-skeleton {
  padding: 24px 0;

  .skeleton-header {
    margin-bottom: 20px;

    .skeleton-title {
      height: 22px;
      width: 180px;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      animation: pulse 1.5s infinite;
    }
  }

  .skeleton-card {
    margin-bottom: 36px;

    .skeleton-card-inner {
      height: 220px;
      background-color: rgba(0, 0, 0, 0.04);
      border-radius: 12px;
      margin-bottom: 16px;
      animation: pulse 1.5s infinite;
    }

    .skeleton-navigation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;

      .skeleton-nav-arrow {
        width: 60px;
        height: 22px;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        animation: pulse 1.5s infinite;
      }

      .skeleton-card-count {
        width: 40px;
        height: 22px;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        animation: pulse 1.5s infinite;
      }
    }
  }

  .skeleton-list {
    .skeleton-item {
      background: rgba(0, 0, 0, 0.02);
      border-radius: 8px;
      margin-bottom: 16px;
      width: calc(100% - 35px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);

      .skeleton-row {
        display: flex;
        align-items: center;
        height: 100px;
        padding: 0 20px;
        position: relative;

        .skeleton-term {
          flex: 3;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.04);
          border-radius: 6px;
          margin-right: 20px;
          animation: pulse 1.5s infinite;
        }

        .skeleton-divider {
          width: 80px;
          height: 4px;
          background-color: rgba(0, 0, 0, 0.05);
          transform: rotate(130deg);
          animation: pulse 1.5s infinite;
        }

        .skeleton-definition {
          flex: 4;
          height: 60px;
          background-color: rgba(0, 0, 0, 0.04);
          border-radius: 6px;
          margin-left: 20px;
          animation: pulse 1.5s infinite;
        }

        .skeleton-edit {
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          background-color: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          animation: pulse 1.5s infinite;
        }
      }
    }
  }
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 0.6;
  }
}

/* 生成中加载状态样式 */
.generating-loader {
  margin-top: 20px;
  padding: 60px 20px;
  text-align: center;
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.03) 0%, rgba(155, 89, 182, 0.03) 100%);
  border-radius: 16px;
  border: 1px solid rgba(52, 152, 219, 0.08);
  margin-bottom: 28px;

  .loader-header {
    margin-bottom: 40px;

    .loader-icon {
      font-size: 48px;
      color: #3498db;
      margin-bottom: 16px;
      animation: spin 2s linear infinite;

      i {
        font-size: 48px;
      }
    }

    .loader-title {
      font-size: 24px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 8px;
    }

    .loader-subtitle {
      font-size: 16px;
      color: #5e6d82;
      line-height: 1.5;
    }
  }

  .progress-bar {
    width: 100%;
    height: 6px;
    background-color: rgba(52, 152, 219, 0.1);
    border-radius: 3px;
    margin-bottom: 40px;
    overflow: hidden;

    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #3498db 0%, #9b59b6 100%);
      border-radius: 3px;
      transition: width 0.3s ease;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: linear-gradient(-45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent);
        background-size: 30px 30px;
        animation: progressStripe 1s linear infinite;
      }
    }
  }

  .loader-steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 600px;
    margin: 0 auto;

    .step {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      opacity: 0.4;
      transition: all 0.3s ease;

      &.active {
        opacity: 1;

        .step-icon {
          background-color: #3498db;
          color: white;
          transform: scale(1.1);
        }
      }

      &.completed {
        opacity: 1;

        .step-icon {
          background-color: #27ae60;
          color: white;

          &::after {
            content: '✓';
            font-size: 12px;
          }
        }
      }

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 16px;
        left: 60%;
        width: 80%;
        height: 2px;
        background-color: rgba(52, 152, 219, 0.2);
        z-index: 0;
      }

      .step-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: rgba(52, 152, 219, 0.1);
        color: #5e6d82;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        z-index: 1;
        position: relative;
      }

      .step-text {
        font-size: 12px;
        color: #5e6d82;
        text-align: center;
        line-height: 1.3;
      }
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes progressStripe {
  from {
    background-position: 30px 0;
  }

  to {
    background-position: 0 0;
  }
}

.cardbox {
  border-radius: 16px;
  padding-bottom: 24px;
  text-align: center;
  margin-bottom: 28px;
  background-color: rgba(52, 152, 219, 0.03);
  border: 1px solid rgba(52, 152, 219, 0.08);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.03);

  .header {
    margin: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: 500;
      display: flex;
      align-items: center;

      .icon {
        margin-right: 12px;
        font-size: 48px;
      }

      .subtitle {
        h1 {
          padding: 0;
          margin: 0 0 10px 0;
          font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 24px;
          color: #2c3e50;
        }

        span {
          font-weight: normal;
          color: #5e6d82;
          font-size: 16px;
        }
      }
    }

    .regenerate-button {
      background-color: #3498db;
      color: white;
      padding: 6px 14px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 6px rgba(52, 152, 219, 0.2);

      &:hover {
        background-color: #2980b9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
      }

      i {
        font-size: 16px;
      }
    }
  }

  .card {
    margin-bottom: 20px;

    .card-inner {
      margin: 0 auto;
      border-radius: 12px;
      padding: 24px;
      height: 220px;
      width: 90%;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: transform 0.6s;
      transform-style: preserve-3d;
      cursor: pointer;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 0, 0, 0.04);

      &.is-flipped {
        transform: rotateX(180deg);
      }
    }

    .card-front,
    .card-back {
      backface-visibility: hidden;
      overflow: auto;
      width: 100%;
      height: 100%;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      /* 自定义滚动条样式 */
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.02);
        border-radius: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.08);
        border-radius: 8px;

        &:hover {
          background: rgba(0, 0, 0, 0.15);
        }
      }
    }

    .card-back {
      transform: rotateX(180deg);
      padding: 16px;
      text-align: center;
    }

    .card-content {
      font-size: 20px;
      color: #2c3e50;
      line-height: 1.6;
    }
  }

  .card-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 90%;
    padding: 0 20px;

    .nav-arrow {
      font-size: 15px;
      margin: 0 10px;
      cursor: pointer;
      color: #3498db;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 8px 12px;
      border-radius: 6px;
      background-color: rgba(52, 152, 219, 0.05);

      &:hover {
        color: #2980b9;
        background-color: rgba(52, 152, 219, 0.1);
        transform: translateY(-2px);
      }

      i {
        font-size: 14px;
      }
    }

    .card-count {
      font-size: 16px;
      margin: 0 30px;
      color: #5e6d82;
      font-weight: 500;
    }
  }
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;

  .action-button {
    flex: 1;
    background-color: #f8f9fa;
    border: 1px solid rgba(0, 0, 0, 0.06);
    font-size: 16px;
    color: #2c3e50;
    padding: 10px 20px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f1f5f9;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    }

    .button-icon {
      margin-right: 10px;
      font-size: 22px;
    }

    .arrow {
      font-size: 16px;
      color: #3498db;
    }
  }
}

.flashcard-list {
  .flashcard-item {
    border-radius: 12px;
    background: #ffffff;
    margin-bottom: 20px;
    width: calc(100% - 30px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }

    .row {
      position: relative;

      .editbox {
        height: 120px;
        position: absolute;
        right: -35px;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .editiconbox {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          box-shadow: 0 2px 6px rgba(52, 152, 219, 0.15);
          transition: all 0.2s ease;
          cursor: pointer;

          &:hover {
            transform: scale(1.1);
            background-color: rgba(52, 152, 219, 0.18);
            box-shadow: 0 4px 8px rgba(52, 152, 219, 0.2);
          }

          .nnf-editicon {
            font-size: 24px;
            color: #263843;
            transition: all 0.2s ease;
          }
        }

        .editoverbox {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;

          div {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.2s ease;

            &:first-child {
              background-color: rgba(52, 152, 219, 0.12);
              box-shadow: 0 2px 6px rgba(52, 152, 219, 0.15);

              &:hover {
                transform: scale(1.1);
                background-color: rgba(52, 152, 219, 0.18);
                box-shadow: 0 4px 8px rgba(52, 152, 219, 0.2);
              }

              .editover {
                font-size: 18px;
                color: #3498db;
              }
            }

            &:last-child {
              background-color: rgba(231, 76, 60, 0.12);
              box-shadow: 0 2px 6px rgba(231, 76, 60, 0.15);

              &:hover {
                transform: scale(1.1);
                background-color: rgba(231, 76, 60, 0.18);
                box-shadow: 0 4px 8px rgba(231, 76, 60, 0.2);
              }

              i.el-icon-close {
                font-size: 18px;
                color: #e74c3c;
              }
            }
          }
        }
      }
    }

    .showbox {
      display: flex;
      align-items: center;
      font-size: 15px;
      height: 120px;

      .item-term {
        padding: 0 5px;
        flex: 3;
        font-weight: 600;
        height: 80px;
        overflow-y: auto;
        display: flex;
        align-items: center;
        color: #2c3e50;

        p {
          padding-left: 20px;
          margin: 0;
          line-height: 1.6;
        }

        /* 自定义滚动条 */
        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.02);
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.08);
          border-radius: 2px;
        }
      }

      .xiefen {
        width: 80px;
        height: 100px;

        .xie {
          position: relative;
          overflow: hidden;
          width: 80px;
          height: 100px;
        }

        .xie::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 141%;
          /* 约为 √2 * 100% */
          height: 2px;
          background: rgba(0, 0, 0, 0.1);
          transform: translate(-50%, -50%) rotate(130deg);
        }
      }

      .item-definition {
        height: 80px;
        overflow-y: auto;
        padding: 0 5px;
        flex: 4;
        color: #5e6d82;
        display: flex;
        align-items: center;
        line-height: 1.5;

        /* 自定义滚动条 */
        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.02);
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.08);
          border-radius: 2px;
        }
      }

      .tera-term {
        font-size: 15px;
        width: calc(100% - 8px);
        height: calc(100% - 10px);
        margin: 0;
        padding: 12px;
        background: rgba(52, 152, 219, 0.03);
        color: #2c3e50;
        border: 1px solid rgba(52, 152, 219, 0.15);
        border-radius: 8px;
        resize: none;
        outline: none;
        -webkit-appearance: none;
        transition: all 0.2s ease;
        line-height: 1.6;

        &:focus {
          border-color: rgba(52, 152, 219, 0.4);
          box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
        }

        &::-moz-focus-inner {
          border: 0;
        }
      }
    }
  }
}

/* 添加响应式调整 */
@media (max-width: 768px) {
  .flashcards-container {
    padding: 0 15px;
  }

  .generating-loader {
    padding: 40px 15px;

    .loader-header {
      margin-bottom: 30px;

      .loader-icon {
        font-size: 40px;
        margin-bottom: 12px;

        i {
          font-size: 40px;
        }
      }

      .loader-title {
        font-size: 20px;
      }

      .loader-subtitle {
        font-size: 14px;
      }
    }

    .progress-bar {
      margin-bottom: 30px;
    }

    .loader-steps {
      .step {
        .step-icon {
          width: 28px;
          height: 28px;
          font-size: 12px;
        }

        .step-text {
          font-size: 11px;
        }
      }
    }
  }

  .cardbox {
    padding: 20px 0;

    .card-inner {
      height: 180px;
      padding: 15px;
      width: 95%;
    }

    .card-navigation {
      width: 95%;
      padding: 0 10px;

      .nav-arrow {
        font-size: 14px;
        padding: 6px 10px;
      }

      .card-count {
        margin: 0 15px;
        font-size: 14px;
      }
    }
  }

  .flashcard-list {
    .flashcard-item {
      width: 100%;

      .row .editbox {
        right: -15px;
      }

      .showbox {
        height: 130px;

        .item-term,
        .item-definition {
          height: 100px;
          padding: 0 15px;
        }

        .xiefen {
          width: 60px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .generating-loader {
    padding: 30px 10px;

    .loader-header {
      margin-bottom: 25px;

      .loader-icon {
        font-size: 36px;
        margin-bottom: 10px;

        i {
          font-size: 36px;
        }
      }

      .loader-title {
        font-size: 18px;
      }

      .loader-subtitle {
        font-size: 13px;
      }
    }

    .progress-bar {
      margin-bottom: 25px;
      height: 5px;
    }

    .loader-steps {
      flex-wrap: wrap;
      gap: 15px;

      .step {
        flex: 0 0 calc(50% - 7.5px);
        margin-bottom: 10px;

        &:not(:last-child)::after {
          display: none;
        }

        .step-icon {
          width: 24px;
          height: 24px;
          font-size: 11px;
        }

        .step-text {
          font-size: 10px;
        }
      }
    }
  }

  .cardbox {
    .card-inner {
      height: 160px;
      padding: 10px;
      width: 100%;
    }

    .card-navigation {
      width: 100%;
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px;

      .nav-arrow {
        order: 2;
        flex: 1;
        text-align: center;
        justify-content: center;
      }

      .card-count {
        order: 1;
        width: 100%;
        text-align: center;
        margin: 0 0 10px 0;
      }
    }
  }

  .flashcard-list {
    .flashcard-item {
      .showbox {
        flex-direction: column;
        height: auto;
        padding: 15px 0;

        .item-term,
        .item-definition {
          width: 100%;
          padding: 10px 15px;
          height: auto;
          max-height: 100px;
          margin: 5px 0;
        }

        .xiefen {
          display: none;
        }
      }

      .row .editbox {
        height: 100%;
        right: -10px;

        .editiconbox,
        .editoverbox div {
          width: 28px;
          height: 28px;
        }

        .editicon,
        .editover,
        i.el-icon-close {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
